import React from 'react';
import SEO from "../common/SEO";
import {FiPhoneCall} from "react-icons/fi";
import ServiceFive from '../elements/service/ServiceFive';
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import Separator from "../elements/separator/Separator";
import TabOne from "../elements/tab/TabOne";
import CallToActionThree from "../elements/calltoaction/CalltoActionThree";
import Layout from "./layout/Layout";


const Home = () => {
    return (
        <>
            <SEO title="Mixon Softwares"/>
            <Layout>
                {/* Start Slider Area  */}
                <div className="slider-area slider-style-1 bg-transparent variation-2 py-lg-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 order-1 order-lg-1 mt_md--40 mt_sm--40">
                                <div className="inner text-left">
                                    <h2 className="text-capitalize">
                                        We are committed to provide you with simple online
                                        business Solutions
                                    </h2>
                                    <p className="description">
                                        We are trusted partners by hundreds of businesses all around, from web design,
                                        development, and web apps to mobile apps development and IT consultancy.
                                    </p>
                                    <div className="button-group">
                                        <a className="btn-default btn-small" href="tel:0713958492"><i
                                            className="icon"><FiPhoneCall/></i> Call Us Now </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 order-2 order-lg-2">
                                <div className="thumbnail">
                                    <img src="./images/banner/bg-image-16.png" alt="Banner Images"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Slider Area  */}

                <Separator/>

                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle="Welcome to Mixon Softwares"
                                    title="Our Solutions"
                                    description="In accordance with the requirements of our clients, we provide
                                    efficient web designs, mobile apps, web applications and customised online solutions.  As your go-to source for online solutions,
                                    we'll not only meet your company's needs but also maintain the integrity of
                                    your corporate identity and guarantee lead generation."
                                />
                            </div>
                        </div>
                        <ServiceFive
                            serviceStyle="gallery-style"
                            textAlign="text-left"
                        />
                    </div>
                </div>
                {/* End Service Area  */}
                <Separator/>


                {/* Start Call To Action Area  */}
                <div className="rwt-callto-action-area">
                    <div className="wrapper">
                        <CallToActionThree/>
                    </div>
                </div>
                {/* End Call To Action Area  */}

                {/* Start API Area  */}
                <div className="rn-service-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title="API Integration"
                                    description="We are surrounded by technologies that communicate with one another,
                                    whether we like it or not. Components interact and 'speak to' one other in the
                                    world of program development. This makes it easier to create more sophisticated
                                    solutions using these pre-built building parts. And that's exactly what API is for:
                                    to make communication easier."
                                />
                            </div>
                        </div>
                        <TabOne/>
                    </div>
                </div>
                {/* End Service Area  */}
            </Layout>
        </>
    )
}
export default Home;
